module.exports = __webpack_public_path__ + "img/circle-silver-logo-small.1099767f.png";